import React, { useEffect, useRef } from "react";
import SectionSubTitle from "../components/SectionSubTitle";
import ValuesCard from "../components/ValuesCard";

const useOnScreen = (ref, setActiveHeader, id) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting === true) setActiveHeader(id);
      },
      { rootMargin: "0px 0px -300px 0px" }
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, setActiveHeader, id]);
};

const Values = ({
  values,
  colorSectionHeaderText,
  colorSectionText,
  setActiveHeader
}) => {
  const id = "values";
  const ref = useRef();
  useOnScreen(ref, setActiveHeader, id);
  return (
    <>
      <SectionSubTitle
        id={id}
        title={"Our Values"}
        colorSectionHeaderText={colorSectionHeaderText}
      />
      <div
        ref={ref}
        style={{ color: colorSectionText }}
        className="grid grid-cols-2 gap-4 xl:gap-6"
      >
        {values.map((item) => (
          <ValuesCard
            key={item.id}
            image={item.image}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </>
  );
};

export default Values;
